import {AiMonitoringSentimentEnum} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

import {NEGATIVE_SENTIMENT_THRESHOLD, POSITIVE_SENTIMENT_THRESHOLD} from './tonality-aspects-const';

export function classifyAspectSentiment(sentiment: number): AiMonitoringSentimentEnum {
    if (sentiment >= POSITIVE_SENTIMENT_THRESHOLD) {
        return AiMonitoringSentimentEnum.positive;
    }

    if (sentiment <= NEGATIVE_SENTIMENT_THRESHOLD) {
        return AiMonitoringSentimentEnum.negative;
    }

    return AiMonitoringSentimentEnum.neutral;
}
